import { QuickfireForceChipSizeCommand } from "quickfire/commands/quickfire-force-chip-size-command";
import quickfireFreeGamesComponent from "quickfire/components/quickfire-free-games-component";
import VAnalytics from "quickfire/components/v-analytics";
import Components from "slotworks/components/components";
import GameState from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import { Services } from "slotworks/services/services";
import Init from "slotworks/state-machine/standard/states/init";
import Sequence from "slotworks/utils/contracts/sequence";

export default class QuickfireInit extends Init {

    protected showQuickfireDialogs() {
        const currentGame = GameState.getCurrentGame();

        if (currentGame && !currentGame.isRecovered) {

            const record = currentGame.getCurrentRecord() as SpinRecord;

            if (record) {
                Components.matrix.jumpToGrid(record.grid);
                Services.transaction.setWinnings(record.cashWon, record.cashWon).execute();
            }
        }

        VAnalytics.init();

        quickfireFreeGamesComponent.init();

        const dialogQueue = [];

        // Adjust chip size message
        if (!(currentGame && currentGame.isRecovered)) {
            dialogQueue.push(() => QuickfireForceChipSizeCommand());
        }

        dialogQueue.push(() => quickfireFreeGamesComponent.intro());

        return new Sequence(dialogQueue);
    }
}
